import routes from '../routes/index.routes';
import { BidderAdvertisers } from '../../pages/bidder-advertisers/index/bidder.advertisers.page';
import { CreateBidderAdvertiser } from '../../pages/bidder-advertisers/create/create-bidder-advertiser.page';
import { EditBidderAdvertiser } from '../../pages/bidder-advertisers/edit/edit-bidder-advertiser.page';

export const BidderAdvertisersRouter = [
	{
		path: routes.bidderAdvertisers.advertisers(),
		element: <BidderAdvertisers />,
	},

	{
		path: routes.bidderAdvertisers.createAdvertiser(),
		element: <CreateBidderAdvertiser />,
	},
	{
		path: routes.bidderAdvertisers.editAdvertiser(':bidderAdvertiserId'),
		element: <EditBidderAdvertiser />,
	},
];
